<div layout-horizontal layout-justify-flex-end layout-align-items-center>
  <rt-group margin-lr margin-tb-medium layout-justify-flex-end>
    <rt-button (click)="cancel.emit()" variant="plain">
      {{ 'app.interview.cancel' | translate }}
    </rt-button>
    <rt-button [disabled]="!isFormValid()" (click)="submit.emit()" variant="primary">
      {{ 'app.interview.add_now' | translate }}
    </rt-button>
  </rt-group>
</div>
